const PAGES_URL = {
    HOME: "/",
    ABOUT: "/sobre",
    SKILLS: "/habilidades",
    JOBS: "/trabalhos",
    CONTACT: "/contato"
}

export default PAGES_URL